<template >
  <v-app >
    <app-header> </app-header>
    <v-main  style="padding: 160px 0px 0px; overflow:hidden;" >
      <!-- Provides the application the proper gutter -->
      <v-container fluid  class="pa-0">
          <router-view/>
      </v-container>
     
    </v-main>
    <app-footer ></app-footer>
  </v-app>
</template>

<script>
import AppHeader from './components/AppHeader'
import AppFooter from './components/AppFooter'
export default {
  components: {
    AppHeader,
    AppFooter
  },

  methods: {
  },


}
</script>



